"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateItemExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const Item_1 = tslib_1.__importDefault(require("./__model__/Item"));
const getItems_1 = tslib_1.__importDefault(require("../../../items/getItems"));
const utils_1 = require("../../../../utils");
const enableItem_1 = tslib_1.__importDefault(require("../enableItem"));
const disableItem_1 = tslib_1.__importDefault(require("../disableItem"));
const updateItem = toolkitRaw.createAsyncThunk('item/update', async ({ data, options }, { rejectWithValue, dispatch, getState }) => {
    var _a, _b, _c, _d;
    const hasItemId = data === null || data === void 0 ? void 0 : data.id;
    if (!hasItemId) {
        return rejectWithValue('[items]: Property id is missing');
    }
    try {
        const state = getState();
        if ((options === null || options === void 0 ? void 0 : options.shouldActiveItem) &&
            ((_b = (_a = state.items.item) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.status) !== 'enabled') {
            dispatch((0, enableItem_1.default)({ internalItemId: data === null || data === void 0 ? void 0 : data.id }));
        }
        if ((options === null || options === void 0 ? void 0 : options.shouldDisableItem) &&
            ((_d = (_c = state.items.item) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.status) !== 'disabled') {
            dispatch((0, disableItem_1.default)({ internalItemId: data === null || data === void 0 ? void 0 : data.id }));
        }
        const itemInstance = new Item_1.default(data);
        await itemInstance.processImages();
        const response = await services_1.default.patch(`/api/saas/me/items/${data === null || data === void 0 ? void 0 : data.id}`, itemInstance.data);
        const deserializedItem = (0, utils_1.deserialize)(response);
        dispatch((0, getItems_1.default)());
        return deserializedItem.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const updateItemExtraReducers = (builder) => {
    builder.addCase(updateItem.pending, (state) => {
        state.item.loading = true;
    });
    builder.addCase(updateItem.fulfilled, (state) => {
        state.item.loading = false;
    });
    builder.addCase(updateItem.rejected, (state) => {
        state.item.loading = false;
    });
};
exports.updateItemExtraReducers = updateItemExtraReducers;
exports.default = updateItem;
//# sourceMappingURL=index.js.map